import { Component, OnInit, ViewChild, ɵConsole } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormControlName, FormArray } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import { CadastroUserTerceiroService } from './cadastro-user-terceiro.service';
import { NotificationsService } from "angular2-notifications";
import { ActivatedRoute } from '@angular/router';
import { DateUtilService } from '../../../../shared/services/date-util.service';
import { Location } from '@angular/common';

@Component({
  selector: 'ngx-cadastro-user-terceiro',
  templateUrl: './cadastro-user-terceiro.component.html',
  styleUrls: ['./cadastro-user-terceiro.component.scss']
})
export class CadastroUserTerceiroComponent implements OnInit {

  salvaCadastro: FormGroup;
  public formCadastroTerceiro = null;
  public listCardStatus = null;
  public isDisabledSaveButton: boolean = false;
  public customLogin = null;
  public yesterday = new Date((new Date()).valueOf() - 1000*60*60*24);
  
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    disableUntil: { year: this.yesterday.getFullYear(), month: this.yesterday.getMonth() + 1, day: this.yesterday.getDate() },
  };
  formListaTerceiro: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private CadastroUserTerceiroService: CadastroUserTerceiroService,
    private notifications: NotificationsService,
    private route: ActivatedRoute,
    private dateUtilService: DateUtilService,
    private location: Location,

  ) {

    this.route.params.subscribe(params => {
      if (params.id) this.listarCadastroUser(params.id)
    });

    this.listCardStatus = [

      {
        status: 'ATIVO',
        descricao: 'ATIVO'
      },

      {
        status: 'INATIVO',
        descricao: 'INATIVO'
      },

    ];

    this.formCadastroTerceiro = this.formBuilder.group({
      id: [null],
      cpf: [null, Validators.required],
      nome: [null, Validators.required],
      email: [null, Validators.required],
      status: [null, Validators.required],
      telefone: [null, Validators.required],
      dataExpiracao: [null],
    });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  salvaUser(data) {

    if (data.dataExpiracao != null) {

      this.dateUtilService.datepickerTransformDate(data.dataExpiracao, 'YYYY-MM-DD')
      let dataExpiracao = this.getDateTimestamp(data.dataExpiracao);
      data.dataExpiracao = dataExpiracao;

    }

    let register = {

      cpf: data.cpf,
      nome: data.nome,
      email: data.email,
      status: data.status,
      telefone: data.telefone,
      dataExpiracao: data.dataExpiracao,

    }

    this.isDisabledSaveButton = true;

    if (data.id === null) {

      this.CadastroUserTerceiroService.salvaCadastro(register)
        .subscribe(
          response => (

            this.formatSaveCadastro(response)

          ), (error) => {
            this.notifications.error(error.error.message);
            this.isDisabledSaveButton = false;
          })
    } else {
      this.CadastroUserTerceiroService.editarCadastroUser(data.id, register)
        .subscribe(
          response => (

            this.formatEditCadastro(response)

          ));

    }
  }

  formatSaveCadastro(ret) {

    if (ret || ret == null) {

      this.salvaCadastro = this.formBuilder.group({

        id: [null],
        cpf: [null],
        nome: [null],
        email: [null],
        status: [null],
        telefone: [null],
        dataExpiracao: [null]

      });

      this.notifications.success(
        "Cadastro realizado com sucesso."
      )
      this.isDisabledSaveButton = false;
      this.limparForm();

    }

  }

  formatEditCadastro(ret) {

    if (ret || ret == null) {

      this.salvaCadastro = this.formBuilder.group({

        id: [null],
        cpf: [null],
        nome: [null],
        email: [null],
        status: [null],
        telefone: [null],
        dataExpiracao: [null]

      });

      this.notifications.success(
        "Alteração realizado com sucesso."
      )
      this.isDisabledSaveButton = false;
      this.limparForm();

    }

  }

  getDateTimestamp(data) {

    let dataReturn = null;
    if ('jsdate' in data) {
      dataReturn = new Date(data.jsdate)
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    } else {
      dataReturn = new Date(data.date['year'], data.date['month'] - 1, data.date['day']).getTime();
      dataReturn = moment(dataReturn).format('YYYY-MM-DD');
    }

    return dataReturn;
  }

  listarCadastroUser(data) {

    this.CadastroUserTerceiroService.listarCadastroUser(data)
      .subscribe(
        response => (
          this.mountEdicaoCadastro(response)
        ));
  }

  mountEdicaoCadastro(data) {

    if (data.id != null) {
      this.formCadastroTerceiro.controls['id'].setValue(data.id);
      this.formCadastroTerceiro.controls['cpf'].setValue(data.cpf);
      this.formCadastroTerceiro.controls['nome'].setValue(data.nome);
      this.formCadastroTerceiro.controls['email'].setValue(data.email);
      this.formCadastroTerceiro.controls['status'].setValue(data.status);
      this.formCadastroTerceiro.controls['telefone'].setValue(data.telefone);
      this.formCadastroTerceiro.controls['dataExpiracao'].setValue(data.dataExpiracao);
    }

    if (data.dataExpiracao !== null) {

      let dateFormatted: Date = this.dateUtilService.parseDate(data.dataExpiracao, 'YYYY-MM-DD')

      this.formCadastroTerceiro.controls['dataExpiracao'].setValue({
        date: {
          day: dateFormatted.getDate(),
          month: dateFormatted.getMonth() + 1,
          year: dateFormatted.getFullYear()
        }
      })
    }

  }

  limparForm() {

    this.formCadastroTerceiro = this.formBuilder.group({
      id: [null],
      cpf: [null],
      nome: [null],
      email: [null],
      status: [null],
      telefone: [null],
      dataExpiracao: [null]

    });

  }

  previousPage() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
